interface AbnyLogoProps {
  size?: number;
  className?: string;
  variant?: 'vector' | 'image' | 'light' | 'dark';
}

export function AbnyLogo({ size = 20, className = '', variant = 'vector' }: AbnyLogoProps) {
  if (variant === 'image') {
    return (
      <img
        src="/abny-logo.jpg"
        alt="ABNY Logo"
        width={size}
        height={size}
        className={className}
        style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          borderRadius: '4px',
          objectFit: 'contain',
        }}
      />
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
      aria-label="ABNY Official Logo"
    >
      {/* Hexagon Mark */}
      <polygon
        points="50,4 92,28 92,72 50,96 8,72 8,28"
        fill="#ffffff"
        stroke="#000000"
        strokeWidth="1.5"
      />
      {/* ABNY Serif Typography */}
      <text
        x="50"
        y="58"
        textAnchor="middle"
        fontFamily="'Times New Roman', Times, 'Georgia', 'Playfair Display', serif"
        fontSize="25"
        fontWeight="700"
        fill="#000000"
        letterSpacing="0.05em"
      >
        ABNY
      </text>
    </svg>
  );
}
